"use client";
import { useKindeSession } from "@/components/KindeWrapper";
import { AddToMyShowButton } from "@/components";
import { Label } from "@/components/ui/label";

export function InfoCard({ categories, slug, type, title, image }) {
  const { user } = useKindeSession();
  const userId = user?.id || null;

  return (
    <div
      className="flex flex-col p-5 space-y-2 bg-white border-2 shadow-lg lg:p-7 rounded-base"
      style={
        type === "rides" || type === "showbags" || type === "food_outlets"
          ? {
              "--button-background": "137 33 2",
              "--button-hover-background": "137 33 2",
              "--button-foreground": "255 255 255",
            }
          : undefined
      }
    >
      <div className="flex justify-between w-full lg:pb-2">
        <h3 className="level-3">Info</h3>
        <AddToMyShowButton
          userId={userId}
          slug={slug}
          type={type}
          title={title}
          image={image}
        />
      </div>

      {categories?.length > 0 && (
        <div className="flex flex-wrap w-1/2 gap-2 lg:w-3/4">
          {categories?.map((category, index) => (
            <Label key={index}>{category?.title}</Label>
          ))}
        </div>
      )}
    </div>
  );
}
